import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "d-flex justify-content-end" };
const _hoisted_2 = ["onUpdate:modelValue"];
const _hoisted_3 = ["onUpdate:modelValue"];
const _hoisted_4 = ["onUpdate:modelValue"];
const _hoisted_5 = ["onUpdate:modelValue"];
const _hoisted_6 = { class: "d-flex flex-wrap" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "row" };
const _hoisted_9 = { class: "col-auto" };
const _hoisted_10 = { class: "input-group" };
const _hoisted_11 = { class: "form-floating" };
const _hoisted_12 = { class: "col-auto" };
const _hoisted_13 = { class: "form-floating" };
const _hoisted_14 = { class: "col-auto" };
const _hoisted_15 = { class: "form-floating" };
import { FilterMatchMode } from '@primevue/core/api';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { useForm } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';
import { formatters } from '@/Composables/formatters';
import YesNoIcon from '@/Shared/YesNoIcon.vue';
import { responseMessages } from '@/Composables/responseMessages';
import { useConfirm } from 'primevue';
import axios from 'axios';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductPriceTable',
    props: {
        priceBundleUuid: String
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage, showSuccessMessage } = responseMessages();
        let { formatCurrency, formatDate } = formatters();
        const props = __props;
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        const confirm = useConfirm();
        const createPriceForm = useForm({
            price: null,
            minAmount: null,
            maxAmount: null
        });
        const prices = ref([]);
        onMounted(() => {
            loadPrices();
        });
        function loadPrices() {
            if (props.priceBundleUuid == null) {
                return;
            }
            axios.post(route('admin.priceBundles.prices.load', props.priceBundleUuid)).then((response) => {
                prices.value = response.data;
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function createPrice() {
            if (props.priceBundleUuid == null) {
                return;
            }
            axios.post(route('admin.priceBundles.prices.store', props.priceBundleUuid), {
                price: createPriceForm.price,
                min_amount: createPriceForm.minAmount,
                max_amount: createPriceForm.maxAmount
            }).then((response) => {
                loadPrices();
                showSuccessMessage('Preis erstellt.');
                createPriceForm.reset();
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        const onCellEditComplete = (event) => {
            let { newData } = event;
            axios.put(route('admin.priceBundles.prices.update', newData.uuid), {
                price: newData.price,
                min_amount: newData.minAmount,
                max_amount: newData.maxAmount,
                active: newData.active
            }).then((response) => {
                prices.value = prices.value.map((price) => {
                    if (price.uuid === newData.uuid) {
                        return { ...price, ...newData };
                    }
                    return price;
                });
                showSuccessMessage('Änderungen gespeichert');
            }).catch((error) => {
                showErrorMessage(error);
            });
        };
        function removePrice(price) {
            confirm.require({
                message: 'Soll der Preis wirklich gelöscht werden?',
                header: 'Preis löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    axios.delete(route('admin.priceBundles.prices.destroy', price.uuid)).then((response) => {
                        prices.value = prices.value.filter((p) => p.uuid !== price.uuid);
                        showSuccessMessage('Preis gelöscht.');
                    }).catch((error) => {
                        showErrorMessage(error);
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _cache[14] || (_cache[14] = _createElementVNode("p", { class: "fw-bold text-danger m-0" }, "Preis-Änderungen gelten global für alle Produkte, die dieses Bundle nutzen.", -1)),
                _createVNode(_unref(DataTable), {
                    class: "mb-4",
                    dataKey: "id",
                    value: prices.value,
                    stripedRows: "",
                    responsiveLayout: "scroll",
                    globalFilterFields: ['price', 'minAmount', 'maxAmount', 'active', 'updatedAt'],
                    filters: tableFilter.value,
                    "onUpdate:filters": _cache[1] || (_cache[1] = ($event) => ((tableFilter).value = $event)),
                    paginator: true,
                    rows: 10,
                    paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                    rowsPerPageOptions: [10, 25, 50, 150],
                    currentPageReportTemplate: "{first} von {last} von insgesamt {totalRecords}",
                    editMode: "cell",
                    onCellEditComplete: onCellEditComplete
                }, {
                    header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((tableFilter.value['global'].value) = $event)),
                                placeholder: "Suche",
                                style: { "width": "250px" }
                            }, null, 512), [
                                [_vModelText, tableFilter.value['global'].value]
                            ])
                        ])
                    ]),
                    empty: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("div", { class: "p-3" }, " Keine Einträge gefunden ", -1)
                        ]))]),
                    loading: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode(" Einträge werden geladen ... ", -1)
                        ]))]),
                    default: _withCtx(() => [
                        _createVNode(_unref(Column), {
                            header: "#",
                            sortable: true
                        }, {
                            body: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(Column), {
                            header: "Preis",
                            sortable: true,
                            sortField: "price"
                        }, {
                            body: _withCtx(({ data }) => [
                                _createTextVNode(_toDisplayString(_unref(formatCurrency)(data.price)), 1)
                            ]),
                            editor: _withCtx(({ data }) => [
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    class: "form-control",
                                    min: "0",
                                    step: "0.01",
                                    "onUpdate:modelValue": ($event) => ((data.price) = $event),
                                    style: { "width": "100px" },
                                    required: ""
                                }, null, 8, _hoisted_2), [
                                    [_vModelText, data.price]
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(Column), {
                            header: "Min. Anzahl",
                            sortable: true,
                            sortField: "minAmount"
                        }, {
                            body: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString(slotProps.data.minAmount), 1)
                            ]),
                            editor: _withCtx(({ data }) => [
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    class: "form-control",
                                    min: "0",
                                    "onUpdate:modelValue": ($event) => ((data.minAmount) = $event),
                                    style: { "width": "100px" },
                                    required: ""
                                }, null, 8, _hoisted_3), [
                                    [_vModelText, data.minAmount]
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(Column), {
                            header: "Max. Anzahl",
                            sortable: true,
                            sortField: "maxAmount"
                        }, {
                            body: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString(slotProps.data.maxAmount), 1)
                            ]),
                            editor: _withCtx(({ data }) => [
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    class: "form-control",
                                    min: "0",
                                    "onUpdate:modelValue": ($event) => ((data.maxAmount) = $event),
                                    style: { "width": "100px" },
                                    required: ""
                                }, null, 8, _hoisted_4), [
                                    [_vModelText, data.maxAmount]
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(Column), {
                            header: "Aktiv",
                            sortable: true,
                            sortField: "active"
                        }, {
                            body: _withCtx((slotProps) => [
                                _createVNode(YesNoIcon, {
                                    answer: slotProps.data.active
                                }, null, 8, ["answer"])
                            ]),
                            editor: _withCtx(({ data }) => [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    value: "1",
                                    "onUpdate:modelValue": ($event) => ((data.active) = $event)
                                }, null, 8, _hoisted_5), [
                                    [_vModelCheckbox, data.active]
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(Column), {
                            header: "Letzte Änderung",
                            sortable: true,
                            sortField: "updatedAt"
                        }, {
                            body: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.updatedAt, true)), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(Column), { header: "" }, {
                            body: _withCtx((slotProps) => [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("button", {
                                        class: "btn",
                                        onClick: ($event) => (removePrice(slotProps.data))
                                    }, [...(_cache[7] || (_cache[7] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-x-circle text-danger",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                            ], -1)
                                        ]))], 8, _hoisted_7)
                                ])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["value", "filters"]),
                _createElementVNode("form", {
                    onSubmit: _withModifiers(createPrice, ["prevent"])
                }, [
                    _cache[13] || (_cache[13] = _createElementVNode("h5", { class: "fw-bold mb-3" }, "Neuer Preis", -1)),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "newPrice",
                                        type: "number",
                                        class: "form-control",
                                        min: "0",
                                        step: "0.01",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(createPriceForm).price) = $event)),
                                        required: ""
                                    }, null, 512), [
                                        [_vModelText, _unref(createPriceForm).price]
                                    ]),
                                    _cache[8] || (_cache[8] = _createElementVNode("label", { for: "newPrice" }, "Preis", -1))
                                ]),
                                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "input-group-text" }, "€", -1))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    min: "1",
                                    class: "form-control",
                                    id: "newMinAmount",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(createPriceForm).minAmount) = $event)),
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(createPriceForm).minAmount]
                                ]),
                                _cache[10] || (_cache[10] = _createElementVNode("label", { for: "newMinAmount" }, "Min. Anzahl", -1))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    class: "form-control",
                                    id: "newMaxAmount",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(createPriceForm).maxAmount) = $event))
                                }, null, 512), [
                                    [_vModelText, _unref(createPriceForm).maxAmount]
                                ]),
                                _cache[11] || (_cache[11] = _createElementVNode("label", { for: "newMaxAmount" }, "Max. Anzahl", -1))
                            ])
                        ]),
                        _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"col-auto d-flex align-items-center\"><button type=\"submit\" class=\"btn btn-success d-inline-flex align-items-center\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-check2\" viewBox=\"0 0 16 16\"><path d=\"M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0\"></path></svg><span class=\"ms-2\">Speichern</span></button></div>", 1))
                    ])
                ], 32)
            ], 64));
        };
    }
});
